import React, { Component } from "react";
import Loader from "../components/loader/loader";
import ModalHead from "../components/modal-head/modalHead";
import * as handler from "../components/utils/handler";
import PrimaryButton from "../components/utils/primaryButton";
import Slot from "../components/slot/slot";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import $ from "jquery";
import moment from "moment";
import { DataService } from "../services/data.service";
import { Empty } from "antd";

// import "moment/locale/es";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";

const queryString = require("query-string");

let lang = queryString.parse(window.location.search).lang;

const {
  defaultTheme,
  defaultAheadDays,
  defaultLang,
  slotsToShowCount,
  applicationProperties: { isUserAuthenication },
  ui: {
    slotScreen: { defaultFontColor, slotSelectionColor },
    nextAndBackBtn: { backgroundColor },
  },
} = window["app-config"];

const appointmentNumber = queryString.parse(
  window.location.search
).appointmentnumber;

const theme =
  queryString.parse(window.location.search).theme == undefined
    ? defaultTheme
    : queryString.parse(window.location.search).theme;

const httpService = new DataService();

class RescheduleAppointment extends Component {
  state = {
    lang: {},
    enableSubmitBtn: false,
    isSlotLoaded: false,
    isAppointmentInfoLoaded: false,
    isRescheduled: true,
    appointmentInfo: null,
    appointmentSlots: [],
    selectedSlot: null,
    isCurrentDateSlots: false,
    selectedDate: moment(new Date()).format("YYYY-MM-DD"),
    appointmentNumber: null,
    redirectUrl: "",
    rescheduleResp: null,
  };

  selectedSlot = null;

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });

    if (
      isUserAuthenication === true &&
      !localStorage.getItem("isLoggedIn") &&
      !localStorage.getItem("email")
    ) {
      this.props.history.push(
        `/login-user?lang=${lang ? lang : defaultLang.split("_")[0]}`
      );
    } else {
      this.getAppointmentInfo();
    }
  }

  getAppointmentInfo = async () => {
    try {
      let response = await httpService.getAppointmentInfo(
        appointmentNumber,
        "",
        ""
      );
      if (
        response.data.response_code === 100 ||
        response.data.response_code === 106
      ) {
        this.setState({
          appointmentInfo: response.data.appointment_info,
          isAppointmentInfoLoaded: true,
        });
        this.getDateTimeSlots(this.state.selectedDate);
      } else if (response.data.response_code === 102) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.AppointmentNotFound,
          this.state.lang.Ok,
          ""
        );

        this.setState({ isAppointmentInfoLoaded: true });
      } else if (response.data.response_code === 103) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.TicketAlreadyIssued,
          this.state.lang.Ok,
          ""
        );
        this.setState({ isAppointmentInfoLoaded: true });
      } else {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          ""
        );
        this.setState({ isAppointmentInfoLoaded: true });
      }
    } catch (error) {
      this.setState({ isAppointmentInfoLoaded: true });
      console.log("ERROR: ", error.message);
    }
  };

  onDateChange = (date, dateString) => {
    if (
      isUserAuthenication === true &&
      !localStorage.getItem("isLoggedIn") &&
      !localStorage.getItem("email")
    ) {
      this.props.history.push(
        `/login-user?lang=${lang ? lang : defaultLang.split("_")[0]}`
      );
    } else {
      this.setState({ isAppointmentInfoLoaded: false, selectedDate: date });
      let formattedDate = moment(date === null ? new Date() : date).format(
        "YYYY-MM-DD"
      );
      this.getDateTimeSlots(formattedDate);
    }
  };

  getDateTimeSlots = async (date) => {
    var dateGiven = moment(date);
    var DAY = dateGiven.day();

    DAY = DAY == 0 ? 7 : DAY;

    try {
      var response = await httpService.getDateTimeSlots(
        this.state?.appointmentInfo.branch_id,
        this.state?.appointmentInfo.category_id,
        date,
        this.state?.appointmentInfo?.FutureDaysForAppointment !== ""
          ? this.state?.appointmentInfo?.FutureDaysForAppointment
          : defaultAheadDays
      );
      if (response.data.error !== undefined && response.data.error === true) {
        this.setState({
          appointmentSlots: undefined,
          isSlotLoaded: true,
          isAppointmentInfoLoaded: true,
        });
      } else if (response.data.appointmentSlots !== null) {
        var appointmentSlots = response.data.appointmentSlots.slice(
          0,
          slotsToShowCount < 0 || slotsToShowCount > 7 ? 7 : slotsToShowCount
        );
        this.setState({
          appointmentSlots: appointmentSlots,
          isSlotLoaded: true,
          isAppointmentInfoLoaded: true,
        });
      } else {
        this.setState({
          appointmentSlots: [],
          isSlotLoaded: true,
          isAppointmentInfoLoaded: true,
        });
      }
      var slotValue = false;
      this.state.appointmentSlots.forEach(function (value, key) {
        if (value.DayID == DAY) {
          if (value.slotDetail.length == 0) {
            slotValue = true;
          }
        }
      });
    } catch (error) {
      console.log(error.message);
      if (
        error.message.includes("timeout") ||
        error.message.includes("ERR_CONNECTION")
      ) {
        this.setState({
          appointmentSlots: undefined,
          isSlotLoaded: true,
          isAppointmentInfoLoaded: true,
        });
      } else {
        this.setState({
          appointmentSlots: [],
          isSlotLoaded: true,
          isAppointmentInfoLoaded: true,
        });
      }
    }
  };

  slotSelection = () => {
    var currContext = this;
    $(document).ready(function () {
      $(".time").click(function () {
        $(".time").each((i, d) => {
          $(d).css("border-color", "#eee");
          $(d).css("color", defaultFontColor);
        });

        theme == "dark"
          ? $(this).css("border-color", "#f4741d")
          : $(this).css("border-color", slotSelectionColor);
        // #f4741d
        theme == "dark"
          ? $(this).css("color", "#f4741d")
          : $(this).css("color", defaultFontColor);
        // $(this).css("color",  currContext.slotColor);

        let slotDate = $(
          $(this).closest($(".sl__modal_calendar-col")).first()[0].innerHTML
        ).attr("date");

        let slotId = $(this).attr("value");
        let time = $(this).attr("time");
        currContext.selectedSlot = `${slotId}|${slotDate}|${time}`;

        // let date = moment(currContext.selectedSlot.split("|")[1]).format(
        //   "YYYY-MM-DD"
        // );
        let date = moment(
          currContext.selectedSlot.split("|")[1],
          "DD-MMM-YYYY"
        ).format("YYYY-MM-DD");
        currContext.setState({ selectedDate: date });
      });
    });
  };

  onRescheduleClick = async () => {
    if (this.selectedSlot === null) {
      handler.showErrMsg(
        this.state.lang.Error,
        this.state.lang.SlotSelectionErrorMsg,
        this.state.lang.Ok,
        this.state.redirectUrl
      );
    } else {
      this.setState({ isRescheduled: false });
      var {
        appointment_number,
        category_id,
        branch_id,
        branch_name,
        branch_address,
        branch_contact,
        user_id,
        payloads,
      } = this.state.appointmentInfo;
      try {
        let response = await httpService.rescheduleAppointment(
          appointment_number,
          category_id,
          category_id,
          branch_id,
          branch_name,
          branch_address,
          branch_contact,
          this.selectedSlot.split("|")[0],
          2,
          this.state.selectedDate,
          user_id,
          1,
          0,
          payloads,
          localStorage.getItem("lang") === "es"
            ? "Sp"
            : localStorage.getItem("lang"),
          this.selectedSlot.split("|")[2]
        );

        console.log("RESCHEDULE RESPONSE", response);
        if (response.data.error !== undefined && response.data.error === true) {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok,
            ""
          );
        } else {
          if (response.data.issueAppointment.resp_status == 1) {
            this.setState({
              rescheduleResp: response,
              isRescheduled: true,
            });
            handler.showSuccessMessage(
              `${this.state.lang.ApptRescheduledSuccessMsg} ${response.data.issueAppointment.appointment_number}`,
              this.state.lang.Ok,
              `${window.location.origin}/updateappointment?lang=${
                lang === undefined ? defaultLang.split("_")[0] : lang
              }&appointmentnumber=${
                response.data.issueAppointment.appointment_number
              }`
            );
          } else if (
            response.data.issueAppointment.resp_message.toLowerCase() ===
            "Appointment quota for this time slot has reached to its maximum value. Try selecting different time slot."
          ) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.TimeSlotQuotaExceed,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === 6) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.AppointmentAlreadyCanceled,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === 7) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.AppointmentExpired,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === 3) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.CantRescheduleApptTcktIssued,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === -2) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.AlreadyServed,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === -3) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.ApptCanceledAutomatically,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === -6) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.YouAlreadyHaveAnAppointment,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === 300) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.UserApptAgent,
              this.state.lang.Ok,
              ""
            );
          } else if (response.data.issueAppointment.resp_status === 301) {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.UserAlreadyApptAgent,
              this.state.lang.Ok,
              ""
            );
          } else {
            handler.showErrMsg(
              this.state.lang.Error,
              this.state.lang.SomeThingWentWrong,
              this.state.lang.Ok,
              ""
            );
          }
        }
      } catch (error) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          ""
        );
        console.log("ERROR IN RESCHEDULE: ", error.message);
      }
      console.log("SELECTED SLOT: ", this.selectedSlot);
    }
  };

  render() {
    this.slotSelection();
    if (
      this.state.isAppointmentInfoLoaded === true &&
      this.state.isSlotLoaded === true
    ) {
      return (
        <div className="container">
          <div className="sl__modal">
            <ModalHead heading={this.state.lang.RescheduleAppointmentHeading} />

            <br />

            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <h2 style={{ color: "#000" }}>
                  {this.state.lang.WhenDoYouMakeAppointment}
                </h2>

                <div className="sl__modal_calendar-row">
                  <div className="sl__modal_calendar-col header">
                    <label className="sl__modal_form--label">
                      {this.state.lang.SelectDate}
                    </label>
                    <div className="sl__modal_calendar_input">
                      <ConfigProvider
                        locale={
                          localStorage.getItem("lang") === "es" ? esES : enUS
                        }
                      >
                        <DatePicker
                          onChange={this.onDateChange}
                          defaultValue={moment(this.state.selectedDate)}
                          format={"DD-MMM-YYYY"}
                          disabledDate={(current) => {
                            return (
                              moment().add(-1, "days") >= current ||
                              moment().add(
                                this.state.appointmentInfo
                                  .FutureDaysForAppointment !== ""
                                  ? this.state.appointmentInfo
                                      ?.FutureDaysForAppointment
                                  : defaultAheadDays,
                                "days"
                              ) <= current
                            );
                          }}
                          allowClear={false}
                        />
                      </ConfigProvider>
                      {this.state.isCurrentDateSlots === true ? (
                        <p style={{ marginTop: "10px" }}>
                          {this.state.lang.NoSlotsAvailable}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="sl__modal_calendar-row">
                  {this.state.appointmentSlots !== null &&
                  this.state.appointmentSlots.length > 0 ? (
                    this.state.appointmentSlots.map((data, index) => {
                      return (
                        <Slot
                          date={data.Date}
                          key={index}
                          timeSlots={data.slotDetail}
                          lang={this.state.lang}
                        ></Slot>
                      );
                    })
                  ) : (
                    <div className="center">
                      <Empty
                        description={this.state.lang.NoSlotsAvailableMsg}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="center"
              style={{ margin: "0 auto", display: "table" }}
            >
              <PrimaryButton
                bgColor={backgroundColor}
                onClick={
                  this.state.isRescheduled === true
                    ? this.onRescheduleClick
                    : null
                }
              >
                {this.state.isRescheduled === false ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : null}
                &nbsp; {this.state.lang.Reschedule}
              </PrimaryButton>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">
          <div className="sl__modal">
            <ModalHead heading={this.state.lang.RescheduleAppointmentHeading} />
            <Loader />
          </div>
        </div>
      );
    }
  }
}

export default RescheduleAppointment;
